import React from 'react';
import Lottie from 'lottie-react';
import bell from '@assets/lotties/bell.json';
import loader from '@assets/lotties/loadingNotification.json';
import { styled } from '@mui/material/styles';

const AnimationLottieRoot = styled(Lottie)({});
const AnimationLottie = ({ type, height, width, loop = true, autoplay = true, ...other }) => {
	let animationData;
	switch (type) {
		case 'bell':
			animationData = bell;
			break;
		case 'loader':
			animationData = loader;
			break;
		default:
			throw new Error(`Unrecognized Lottie type: ${type}`);
	}
	return (
		<AnimationLottieRoot
			animationData={animationData}
			loop={loop}
			autoplay={autoplay}
			style={{
				height: height || '100%',
				width: width || '100%',
			}}
			{...other}
		/>
	);
};
export { AnimationLottie };
